import { apiClient, API_BASE_URL } from "../index";

const ADMIN_USERS_PATH = "/api/v1/auth/admin-users";
const PLATFORM_ADMINS_PATH = "/api/v1/auth/platform-admins";
const ORGANIZATIONS_PATH = "/api/v1/organizations/";
const ADMIN_TEAMS_BY_ORG_PATH = "/api/v1/teams/admin/by-org";
const ADMIN_TEAM_SCENARIO_PATH = "/api/v1/team-scenario/admin";


/**
 * Create a new admin user (company_admin or university_admin).
 * Requires platform_admin role. An invite email is sent to the new admin to set their password.
 */
export async function createAdminUser({
  role,
  organizationName,
  organizationId,
  firstName,
  lastName,
  email,
  username,
}) {
  const payload = {
    role,
    organization_name: organizationName,
    organization_id: organizationId,
    first_name: firstName,
    last_name: lastName,
    email,
    username,
  };
  return apiClient.post(ADMIN_USERS_PATH, payload);
}

/**
 * Create a new platform admin.
 * Requires platform_admin role. An invite email is sent to the new admin to set their password.
 */
export async function createPlatformAdminUser({
  firstName,
  lastName,
  email,
  username,
}) {
  const payload = {
    first_name: firstName,
    last_name: lastName,
    email,
    username,
  };
  return apiClient.post(PLATFORM_ADMINS_PATH, payload);
}

export async function getAdminUsers() {
  return apiClient.get(ADMIN_USERS_PATH);
}

export async function createOrganization({ name, orgType }) {
  const payload = {
    name,
    org_type: orgType,
  };

  return apiClient.post(ORGANIZATIONS_PATH, payload);
}

export async function getOrganizations({ page = 1, pageSize = 100 } = {}) {
  const query = new URLSearchParams({
    page: String(page),
    page_size: String(pageSize),
  });

  return apiClient.get(`${ORGANIZATIONS_PATH}?${query.toString()}`);
}

export async function getTeamsByOrg({ orgId, page = 1, pageSize = 100 }) {
  const query = new URLSearchParams({
    page: String(page),
    page_size: String(pageSize),
  });
  return apiClient.get(
    `${ADMIN_TEAMS_BY_ORG_PATH}/${orgId}?${query.toString()}`,
  );
}

export async function startTeamScenarioAsPlatformAdmin({ scenarioId, teamId }) {
  return apiClient.post(`${ADMIN_TEAM_SCENARIO_PATH}/start`, {
    scenario_id: scenarioId,
    team_id: teamId,
  });
}

export async function stopTeamScenarioAsPlatformAdmin({ scenarioId, teamId }) {
  const query = teamId
    ? `?${new URLSearchParams({ team_id: teamId }).toString()}`
    : "";
  return apiClient.del(`${ADMIN_TEAM_SCENARIO_PATH}/${scenarioId}${query}`);
}

export async function getAllOrgStartedTeamScenarios() {
  return apiClient.get(`${ADMIN_TEAM_SCENARIO_PATH}/all-org-started`);
}

export async function getTeamScenarioAsPlatformAdmin({ scenarioId, teamId }) {
  const query = teamId
    ? `?${new URLSearchParams({ team_id: teamId }).toString()}`
    : "";
  return apiClient.get(`${ADMIN_TEAM_SCENARIO_PATH}/${scenarioId}${query}`);
}

export function getPlatformTeamAnswersStreamUrl({ scenarioId, teamId }) {
  const query = teamId
    ? `?${new URLSearchParams({ team_id: teamId }).toString()}`
    : "";
  return `${API_BASE_URL}${ADMIN_TEAM_SCENARIO_PATH}/${scenarioId}/answers/stream${query}`;
}